import { EventAggregator } from '@src/infrastructure/eventAggregator';
import { Toast, ToastType } from './toast';

export { Toast, ToastType };

export class Toaster {
    private readonly eventAggregator: EventAggregator;
    private static instance: Toaster;
    private toasts: KnockoutObservableArray<Toast> = ko.observableArray([]);
    private uniqueIds = 1;

    private constructor() {
        this.eventAggregator = new EventAggregator();
        ko.applyBindings(this, document.getElementById('toaster'));
        this.eventAggregator.subscribe('CloseClicked', this.toastClosed)
    }

    private static getInstance(): Toaster {
        if (!Toaster.instance) {
            Toaster.instance = new Toaster();
        }
        return Toaster.instance;
    }

    private toastClosed = (toast: Toast) => {
        this.toasts.remove(toast);
    }

    public static show(toastType: ToastType, message: string): Toast {
        const toaster = this.getInstance();
        if (toaster.toasts().length > 0) {
            let newToastRequired: boolean = true;

            for (let i = 0, len = toaster.toasts().length; i < len; ++i) {
                let existingToast = toaster.toasts()[i];
                if (message === existingToast.message()) {
                    newToastRequired = false;
                    let count: number;
                    if (existingToast.duplicateCount() === '') {
                        count = 0;
                    }
                    else {
                        count = +existingToast.duplicateCount();
                    }
                    count++;
                    existingToast.duplicateCount(count.toString());
                    existingToast.duplicateCountClass("toast-counter");
                    return existingToast;
                }
            }
            //If no existing toast in the array was found, create a new one for specific message type. 
            if (newToastRequired) {
                const toast = new Toast(++toaster.uniqueIds, toaster.eventAggregator, toastType, message);
                toaster.toasts.push(toast);
                toast.show();
                return toast;
            }
        }
        else { //Create first toast in array
            const toast = new Toast(++toaster.uniqueIds, toaster.eventAggregator, toastType, message);
            toaster.toasts.push(toast);
            toast.show();
            return toast;
        }
    }
}